import React, { useState, useEffect, useRef } from "react";
import '../App.css';
import { useNavigate } from 'react-router-dom';
import AppTopBar2 from './common/app-top-bar2';
import AppLoading from './common/app-loading';
import { Box, Grid } from '@mui/material';
import { AppHelper } from '../AppHelper';

const configJson = require('../config.json?v=20230925');

export default function PageHome() {
  const navigate = useNavigate();
  var oUser = AppHelper.userCacheGet();
  
  const [isLoading, setIsLoading] = useState(false);
  const drawerWidth = 0;//240;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [profileId, setProfileId] = useState('');
  const refTopBar = useRef(null);
  const [isSa, setIsSa] = React.useState(false);

  useEffect(()=>{
    if(!oUser){
      navigate('/login');
      return;
    }
    AppHelper.apiAuditPost("P-H", "");
    if(!oUser.profileId){
    }
    if(profileId=='') setProfileId(oUser.profileId);

    const fetchIAM = async()=>{
      var _res = await AppHelper.apiPost('api/account/iam', {token: oUser.token});
      if(!_res || !_res.status || !_res.data || !_res.data.isSa){
        return;
      }
      setIsSa(true);
    }
    fetchIAM();	
	
	const ws = new WebSocket(configJson.wsUrl); 

    ws.onopen = () => {
    };

    ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === "UPDATE") {
            alert(`New update: ${data.message}`); // ✅ Show alert when update is received
        }
    };

    ws.onclose = () => {
    };

    return () => {
        ws.close();
    };
	
  }, []);
  const mobileOpenClick = (arg)=>{
    setMobileOpen(!mobileOpen);
  };
  const go2HomeEssay = ()=>{
    navigate('/home-essay');
  }
  const go2HomeExercise = ()=>{
    navigate('/home-exercise');
  }

    const ActionLink = ({ emoji, title, caption, onClick, ariaLabel, tag }) => (
    <button className="action" onClick={onClick} aria-label={ariaLabel}>
      <div className="circle">
        <div>
          <span className="emoji" aria-hidden="true">{emoji}</span>
          <span className="title">{title}</span>
        </div>
      </div>
      <div className="caption">
        {caption} {tag ? <span className="tag">{tag}</span> : null}
      </div>
    </button>
  );

  return (  
  <Box
    sx={{
      margin: 0,
      background: 'var(--bg)',
      color: 'var(--text)',
      font: '18px/1.6 -apple-system, "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial',
      WebkitFontSmoothing: 'antialiased',
      textRendering: 'optimizeLegibility',
      display: 'flex',
      flexDirection: 'column',
    }}
  >

    <AppTopBar2
      mobileOpen={mobileOpen}
      mobileOpenClick={mobileOpenClick}
      ref={refTopBar}
    />
    {isLoading ? (
      <AppLoading />
    ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            width: { md: `calc(100% - ${drawerWidth}px)` },
            marginTop: '50px',
          }}
        >
          <div class="wrap">
            <nav class="actions" aria-label="Primary actions">
              <a class="action" href="/home-essay" aria-label="Start an Essay practice">
                <div class="circle">
                  <div>
                    <span class="emoji" aria-hidden="true">✍️</span>
                    <span class="title">ESSAY</span>
                  </div>
                </div>
                <div class="caption">Plan • Write • Improve</div>
              </a>

              <a class="action" href="/home-exercise" aria-label="Exercise: Sentence Transformation">
                <div class="circle">
                  <div>
                    <span class="emoji" aria-hidden="true">🧩</span>
                    <span class="title">EXERCISE</span>
                  </div>
                </div>
                <div class="caption">Sentence Transformation</div>
              </a>

              <a class="action" href="https://learn.essayace.ai/" target="_blank" rel="noopener noreferrer" aria-label="Learn with Word Safari">
                <div class="circle">
                  <div>
                    <span class="emoji" aria-hidden="true">🦁</span>
                    <span class="title">LEARN</span>
                  </div>
                </div>
                <div class="caption">Play: Word Safari <span class="tag">NEW</span></div>
              </a>
            </nav>
          </div>
        </Box>
    )}
  </Box>
);

  // <Box sx={{ display: 'flex', flexDirection: 'column' }}>
  //   <AppTopBar2
  //     mobileOpen={mobileOpen}
  //     mobileOpenClick={mobileOpenClick}
  //     ref={refTopBar}
  //   />
  //   {isLoading ? (
  //     <AppLoading />
  //   ) : (
  //     <>
  //       <Box
  //         component="main"
  //         sx={{
  //           flexGrow: 1,
  //           p: 0,
  //           width: { md: `calc(100% - ${drawerWidth}px)` },
  //           marginTop: '50px',
  //         }}
  //       >
  //         <Grid container>
  //           <Grid item xs={12}>
  //             <Box
  //               display="flex"
  //               justifyContent="center"
  //               alignItems="center"
  //               minHeight="87vh"
  //             >
  //               <Box
  //                 sx={{
  //                   display: 'flex',
  //                   gap: '20px',
  //                   flexDirection: {
  //                     xs: 'column', // Vertical layout for mobile
  //                     sm: 'row',   // Horizontal layout for tablet and desktop
  //                   },
  //                   justifyContent: 'center',
  //                   alignItems: 'center',
  //                 }}
  //               >
  //                 <div onClick={go2HomeEssay} className="home-menu-circle">
  //                   ESSAY
  //                 </div>
  //                 <div onClick={go2HomeExercise} className="home-menu-circle">
  //                   EXERCISE
  //                 </div>
  //               </Box>
  //             </Box>
  //           </Grid>
  //         </Grid>
  //       </Box>
  //     </>
  //   )}
  // </Box>
// );
}
